export enum AnswerType {
    yes_no = "yes_no",
    number = "number",
    short_text = "short_text",
    choice = "choice",
    choices = "choices",
}
